import { useEffect, useRef } from 'react';
import ChatMessagesView from './ChatMessages.View';
import { ChatMessagesProps } from './types';

const ChatMessages = (props: ChatMessagesProps) => {
  const { messages, loading } = props;
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      // always scroll to the bottom when new messages are added
      containerRef.current.scrollTo({ top: 9999999, behavior: 'smooth' });
    }
  }, [messages, loading]);

  return <ChatMessagesView {...props} container={containerRef} />;
};

export default ChatMessages;
